<template>
    <page-header-wrapper>
      <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <!-- <a-col :md="8" :sm="24">
                <a-form-item label="套餐名称" prop="memberName">
                  <a-input v-model="queryParam.memberName" placeholder="请输入套餐名称" @pressEnter="handleQuery" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="用户账号" prop="mobile">
                  <a-input v-model="queryParam.mobile" placeholder="请输入用户账号" @pressEnter="handleQuery" allow-clear/>
                </a-form-item>
              </a-col> -->
              <template >
                <!-- <a-col :md="8" :sm="24">
                  <a-form-item label="状态" prop="status">
                    <a-select v-model="queryParam.status">
                      <a-select-option :value="0">待支付</a-select-option>
                      <a-select-option :value="1">已支付</a-select-option>
                      <a-select-option :value="-1">已过期</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :md="8" :sm="24">
                  <a-form-item label="类型" prop="type">
                    <a-select v-model="queryParam.type">
                      <a-select-option :value="1">充值</a-select-option>
                      <a-select-option :value="2">支付</a-select-option>
                      <a-select-option :value="3">退款</a-select-option>

                      <a-select-option :value="2">支付</a-select-option>

                    </a-select>
                  </a-form-item>
                </a-col> -->
                <a-col :md="8" :sm="24">
                  <a-form-item label="开始时间" prop="createBeginTime">
                    <a-date-picker
                      style="width: 100%"
                      show-time
                      v-model="queryParam.createBeginTime"
                      format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="结束时间" prop="createEndTime">
                    <a-date-picker
                      style="width: 100%"
                      show-time
                      v-model="queryParam.createEndTime"
                      format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :md="!advanced && 8 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作 -->
        <!-- <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['member:memberOrder:add']">-->
  <!--          <a-icon type="plus" />新增-->
  <!--        </a-button>-->
  <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['member:memberOrder:edit']">-->
  <!--          <a-icon type="edit" />修改-->
  <!--        </a-button>-->
          <!-- <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['member:memberOrder:remove']">
            <a-icon type="delete" />删除
          </a-button> -->
  <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['member:memberOrder:export']">-->
  <!--          <a-icon type="download" />导出-->
  <!--        </a-button>-->
          <!-- <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div> -->
        <!-- 增加修改 -->
        <create-form
          ref="createForm"
          @ok="getList"
        />
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 390px)'}"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >
        <span slot="index" slot-scope="text, record,index">
         {{(current-1)*size+index+1}}
        </span>
          <span slot="payTime" slot-scope="text, record">
            {{ parseTime(record.payTime) }}
          </span>
          <span slot="validDate" slot-scope="text, record">
            {{ parseTime(record.validDate) }}
          </span>
          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
          <span slot="operation" slot-scope="text, record, index"  v-if="type!='tk'">
  <!--          <a-divider type="vertical" v-hasPermi="['member:memberOrder:edit']" />-->
  <!--          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['member:memberOrder:edit']">-->
  <!--            <a-icon type="edit" />修改-->
  <!--          </a>-->
  <!--          <a-divider type="vertical" v-hasPermi="['member:memberOrder:remove']" />-->
            <!-- <a v-if="record.type ==2" @click="viewItem(record)" v-hasPermi="['user:balanceRecord:list']">
              <a-icon type="search" />查看明细
            </a> -->
            <!-- <a @click="handleDelete(record, index)" v-hasPermi="['member:memberOrder:remove']">
              <a-icon type="delete" />删除
            </a> -->
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </page-header-wrapper>
  </template>

  <script>
  // import { pageMemberOrder,listMemberOrder, delMemberOrder } from '@/api/member/memberOrder'
 import {getBalanceRecord} from '@/api/user/scoreRecord'
  import CreateForm from './modules/CreateForm'
  import { tableMixin } from '@/store/table-mixin'
  import moment from "moment";

  export default {
    name: 'UserRechargeOrders',
    components: {
      CreateForm
    },
    props:["type"],
    mixins: [tableMixin],
    data () {
      return {
        list: [],
        selectedRowKeys: [],
        selectedRows: [],
        // 高级搜索 展开/关闭
        advanced: false,
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        ids: [],
        //索引indexs
        indexs: [],
        loading: false,
        total: 0,
        current: 0,
        size: 0,
        // 查询参数
        queryParam: {

          userId: null,
          createBeginTime:"",
        createEndTime:"",
        direction:"",
        type:null,
          pageNum: 1,
          pageSize: 10
        },
        columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
         },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作前余额',
          dataIndex: 'beforeBalance',
          ellipsis: true,
          align: 'center'
        },


        {
          title: '变动余额',
          dataIndex: 'balance',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作后余额',
          dataIndex: 'afterBalance',
          ellipsis: true,
          align: 'center',

        },

        // {
        //   title: '方向',
        //   dataIndex: 'direction',
        //   ellipsis: true,
        //   align: 'center',
        //      customRender:function (e) {
        //     if(e === 1){
        //       return "收入";
        //     } else {
        //       return "支出";
        //     }
        //   }
        // },
        {
          title: '是否充值成功',
          dataIndex: 'isRecharge',
          scopedSlots: { customRender: 'isRecharge' },
          ellipsis: true,
          align: 'center',
          customRender:function (e) {
            if(e === 0){
              return "否";
            } else {
              return "是";
            }
          }
        },
        {
          title: '支付单号',
          dataIndex: 'payNo',
          scopedSlots: { customRender: 'payNo' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '总金额',
        //   dataIndex: 'totalBalance',
        //   scopedSlots: { customRender: 'totalBalance' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '类型',
        //   dataIndex: 'type',
        //   scopedSlots: { customRender: 'type' },
        //   ellipsis: true,
        //   align: 'center',
        //   customRender:function (e) {
        //     if(e === 1){
        //       return "充值";
        //     }
        //     else  if(e === 2){
        //       return "支付";
        //     }
        //     else  if(e === 3){
        //       return "退款";
        //     }
        //     else  if(e === 4){
        //       return "提现";
        //     }
        //     else if(e === 7) {
        //       return "冻结";
        //     }
        //   }
        // },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        }
        ]
      }
    },
    filters: {
    },
    mounted() {
        if(this.type!='tk'){
          this.getList()
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
      goList(record, type) {
        var this_ = this
        this_.$nextTick(() => {
          this_.queryParam.userId = record.id
          // this_.queryParam.type = type
          this_.list = []
          this_.total = 0
          this_.current = 0
          this_.size = 0
          this_.getList()//这是我自定义的
        })
      },
      /** 查询会员订单列表 */
      getList () {
        if(this.queryParam.createBeginTime){
          this.queryParam.createBeginTime = moment(this.queryParam.createBeginTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if(this.queryParam.createEndTime){
          this.queryParam.createEndTime = moment(this.queryParam.createEndTime).format('YYYY-MM-DD HH:mm:ss')
        }
        this.loading = true
        getBalanceRecord(this.queryParam).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.current = response.data.current
          this.size = response.data.size
          this.loading = false
        })
      },
      viewItem(record){
        this.$router.push({path:'/app/user/memberOrderItem',query:{orderId:record.id}})
      },
      /** 搜索按钮操作 */
      handleQuery () {
        this.queryParam.pageNum = 1
        this.getList()
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParam = {
          memberId: undefined,
          orderNo: undefined,
          userId: undefined,
          status: undefined,
          payMethod: undefined,
          totalAmount: undefined,
          discountAmount: undefined,
          payTime: undefined,
          payAmount: undefined,
          validDate: undefined,
          pageNum: 1,
          pageSize: 10
        }
        this.handleQuery()
      },
      onShowSizeChange (current, pageSize) {
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      changeSize (current, pageSize) {
        this.queryParam.pageNum = current
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.ids = this.selectedRows.map(item => item.id)
           // 列表顶部删除indexs
           if(this.selectedRowKeys.length){
          const indexList = this.selectedRowKeys.map(item=>{
            return this.list.findIndex(i=>i.id === item)
          })
          this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
            return (this.current - 1) * this.size + ind + 1
          })
        }
        this.single = selectedRowKeys.length !== 1
        this.multiple = !selectedRowKeys.length
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      /** 删除按钮操作 */
      handleDelete(row,index) {
        var that = this
        const ids = row.id || this.ids
        const inds = (this.current - 1) * this.size + index + 1
        const indexs = inds || this.indexs.sort((a, b) => a - b)
        this.$confirm({
          title: '确认删除所选中数据?',
          content: '当前选中序号为' + indexs + '的数据',
          onOk () {
            let data = []
            if(row.id){
                  data.push({"id":row.id})
                }else {
                  that.ids.map(id => data.push({"id":id}))
                }
            return delMemberOrder(data)
              .then(() => {
                that.onSelectChange([], [])
                that.getList()
                that.$message.success(
                  '删除成功',
                  3
                )
            })
          },
          onCancel () {
            //取消清空删除ids列表
            // that.ids = []
          }
        })
      },
      /** 导出按钮操作 */
      handleExport () {
        var that = this
        this.$confirm({
          title: '是否确认导出?',
          content: '此操作将导出当前条件下所有数据而非选中数据',
          onOk () {
            that.download('member/memberOrder/export', {
              ...that.queryParam
            }, `会员订单_${new Date().getTime()}.xlsx`)
          },
          onCancel () {}
        })
      }
    }
  }
  </script>
